import { CreateOrderData } from '../services/orderService';
import { Customer, Order } from '../types';

export function orderToFormData(order: Order, customers: Customer[]): CreateOrderData {
  const customer = order.customer_id ? customers.find((c) => c.id === order.customer_id) : undefined;
  const locs = customer?.locations ?? [];
  const matchingLoc = locs.find(
    (l) =>
      (l.project_district ?? '') === (order.district ?? '') &&
      (l.project_location ?? '') === (order.destination ?? '')
  );
  const locationId = matchingLoc?.id ?? locs[0]?.id;
  const loc = locs.find((l) => l.id === locationId) ?? locs[0];

  return {
    order_date: order.order_date,
    sales_officer_id: order.sales_officer_id,
    brand_id: order.brand_id,
    supplier_id: order.supplier_id,
    customer_id: order.customer_id,
    customer_code: order.customer_code,
    location_id: locationId,
    district: loc?.project_district ?? order.district ?? '',
    destination: loc?.project_location ?? order.destination ?? '',
    product_type: order.product_type,
    quantity: order.quantity,
    price_per_bag: order.price_per_bag,
    order_number: order.order_number,
    order_type: order.order_type || 'FOR',
    payment_status: order.payment_status,
    po_status: order.po_status,
    dispatch_status: order.dispatch_status,
    invoice_status: order.invoice_status,
  };
}

export const defaultOrderFormData = (): CreateOrderData => ({
  order_date: new Date().toISOString().split('T')[0],
  sales_officer_id: 0,
  brand_id: 0,
  order_type: 'FOR',
});
